function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Button, Form, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import addMonths from 'date-fns/addMonths';
import parse from 'date-fns/parse';
import isBefore from 'date-fns/isBefore';
import addMinutes from 'date-fns/addMinutes';
import format from "date-fns/format";
import { fr } from 'date-fns/locale';
import "./Reservation.scss";
import TimePicker from './TimePicker';

const getDayOfTheWeek = date => {
  return date.getDay() ? date.getDay() - 1 : 6;
};

const getFirstAvailableDateOfDay = (date, dayTimes) => {
  for (let i = 0; i < dayTimes.length; ++i) {
    const now = new Date();
    let dateStart = parse(dayTimes[i].start, 'HH:mm', date);
    const dateEnd = parse(dayTimes[i].end, 'HH:mm', date);

    while (isBefore(dateStart, dateEnd)) {
      if (dateStart > now) return dateStart;
      dateStart = addMinutes(dateStart, 15);
    }
  }

  return null;
};

class ReservationForm extends React.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onConfirmReservation", e => {
      e.preventDefault();
      const form = e.currentTarget;

      if (form.checkValidity() === false) {
        e.stopPropagation();
        return;
      }

      this.props.onConfirm({
        reservationDate: this.state.reservationDate,
        nbAdult: this.state.nbAdult,
        phone: this.state.phone,
        email: this.state.email,
        firstname: this.state.firstname,
        lastname: this.state.lastname,
        comment: this.state.comment,
        status: 'En attente'
      }).then(() => this.setState({
        step: 5
      }));
    });

    _defineProperty(this, "onInputChange", e => {
      this.setState({
        [e.target.name]: e.target.value
      });
    });

    const times = Array(7);

    for (let i = 0; i < 7; ++i) {
      times[i] = [];
      const day = props.reservationSettings.schedule ? props.reservationSettings.schedule[i] : [];

      if (day) {
        for (let ii = 0; ii < day.length; ++ii) {
          const timeRange = day[ii].split('-');
          times[i].push({
            start: timeRange[0],
            end: timeRange[1]
          });
        }
      }
    }

    this.times = times;
    this.state = {
      step: 1,
      reservationDate: null,
      nbAdult: null,
      nbAdultInput: '',
      phone: '',
      email: '',
      firstname: '',
      lastname: '',
      comment: ''
    };
    this.uniqueId = "reservation-form-" + Math.trunc(Date.now() / 1000 * (Math.random() * 7));
  }

  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "reservation-form",
      id: this.uniqueId
    }, this.props.reservationSettings.color && /*#__PURE__*/React.createElement("style", null, `#${this.uniqueId} {
              --reservation-form-color: ${this.props.reservationSettings.color}
            }`), this.state.step !== 5 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "header-image"
    }, /*#__PURE__*/React.createElement("img", {
      className: "restaurant-img",
      src: this.props.reservationSettings.imgPath,
      alt: "restaurant-logo"
    })), /*#__PURE__*/React.createElement("h1", null, this.props.reservationSettings.restoName), /*#__PURE__*/React.createElement("div", {
      className: "breadcrumbs"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        if (this.state.step > 1) this.setState({
          step: 1
        });
      },
      className: `step ${this.state.step === 1 ? 'selected' : ''} ${this.state.step > 1 ? 'passed' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-title"
    }, "Date"), this.state.step > 1 && /*#__PURE__*/React.createElement("div", {
      className: "step-data"
    }, format(this.state.reservationDate, 'dd LLL yyyy'))), /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        if (this.state.step > 2) this.setState({
          step: 2
        });
      },
      className: `step ${this.state.step === 2 ? 'selected' : ''} ${this.state.step > 2 ? 'passed' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-title"
    }, "Heure"), this.state.step > 2 && /*#__PURE__*/React.createElement("div", {
      className: "step-data"
    }, format(this.state.reservationDate, 'HH:mm'))), /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        if (this.state.step > 3) this.setState({
          step: 3
        });
      },
      className: `step ${this.state.step === 3 ? 'selected' : ''} ${this.state.step > 3 ? 'passed' : ''}`
    }, /*#__PURE__*/React.createElement("div", {
      className: "step-title"
    }, "Couverts"), this.state.step > 3 && /*#__PURE__*/React.createElement("div", {
      className: "step-data"
    }, this.state.nbAdult)))), this.state.step === 1 && /*#__PURE__*/React.createElement("div", {
      className: "step1-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step1-calendar-container"
    }, /*#__PURE__*/React.createElement(DatePicker, {
      disabledKeyboardNavigation: true,
      locale: fr,
      onChange: date => {
        // const dayOfTheWeek = getDayOfTheWeek(date)
        // const realDate = getFirstAvailableDateOfDay(date, this.times[dayOfTheWeek]);
        this.setState({
          reservationDate: date,
          step: 2
        });
      },
      selected: this.state.reservationDate,
      minDate: new Date(),
      maxDate: addMonths(new Date(), 2),
      showPreviousMonths: false,
      renderCustomHeader: ({
        date,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled
      }) => /*#__PURE__*/React.createElement("div", {
        className: "react-datepicker__header-container"
      }, /*#__PURE__*/React.createElement("button", {
        className: "react-datepicker__navigation react-datepicker__navigation--previous",
        onClick: decreaseMonth,
        disabled: prevMonthButtonDisabled
      }), /*#__PURE__*/React.createElement("div", {
        className: "react-datepicker__current-month"
      }, format(date, 'MMMM yyyy', {
        locale: fr
      })), /*#__PURE__*/React.createElement("button", {
        className: "react-datepicker__navigation react-datepicker__navigation--next",
        onClick: increaseMonth,
        disabled: nextMonthButtonDisabled
      })),
      filterDate: date => {
        const dayOfTheWeek = getDayOfTheWeek(date);
        return this.times[dayOfTheWeek].length > 0;
      },
      inline: true
    }))), this.state.step === 2 && /*#__PURE__*/React.createElement("div", {
      className: "reservation-step2"
    }, /*#__PURE__*/React.createElement(TimePicker, {
      selected: this.state.reservationDate,
      creneaux: this.times,
      onChange: date => this.setState({
        reservationDate: date,
        step: 3
      })
    })), this.state.step === 3 && /*#__PURE__*/React.createElement("div", {
      className: "reservation-step3"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "number-people"
    }, /*#__PURE__*/React.createElement("h4", null, "Nombre de personnes"), /*#__PURE__*/React.createElement("div", {
      className: "button-container"
    }, new Array(10).fill(null).map((e, i) => /*#__PURE__*/React.createElement("div", {
      className: `people-button ${this.state.nbAdult === i && 'selected'}`,
      onClick: () => this.setState({
        nbAdult: i,
        step: 4
      })
    }, i)), /*#__PURE__*/React.createElement("div", {
      className: "people-button"
    }, /*#__PURE__*/React.createElement("input", {
      type: "number",
      placeholder: "10+...",
      value: this.state.nbAdultInput,
      onChange: e => this.setState({
        nbAdultInput: e.target.value
      })
    })), this.state.nbAdultInput && /*#__PURE__*/React.createElement("div", {
      className: "people-button",
      onClick: () => this.setState({
        nbAdult: Number.parseInt(this.state.nbAdultInput),
        step: 4
      })
    }, "OK"))))), this.state.step === 4 && /*#__PURE__*/React.createElement("div", {
      className: "reservation-step4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "recap-form"
    }, /*#__PURE__*/React.createElement(Form, {
      onSubmit: this.onConfirmReservation
    }, /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Col
    }, /*#__PURE__*/React.createElement(Form.Control, {
      required: true,
      name: "lastname",
      value: this.state.lastname,
      type: "text",
      placeholder: "Nom*",
      onChange: this.onInputChange
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Col
    }, /*#__PURE__*/React.createElement(Form.Control, {
      required: true,
      name: "firstname",
      value: this.state.firstname,
      type: "text",
      placeholder: "Pr\xE9nom*",
      onChange: this.onInputChange
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Col
    }, /*#__PURE__*/React.createElement(Form.Control, {
      required: true,
      name: "phone",
      value: this.state.phone,
      type: "tel",
      placeholder: "Num\xE9ro de t\xE9l\xE9phone*",
      onChange: this.onInputChange
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Col
    }, /*#__PURE__*/React.createElement(Form.Control, {
      required: true,
      name: "email",
      phone: this.state.email,
      type: "email",
      placeholder: "Adresse email*",
      onChange: this.onInputChange
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Form.Group, {
      as: Col
    }, /*#__PURE__*/React.createElement(Form.Control, {
      name: "comment",
      value: this.state.comment,
      as: 'textarea',
      placeholder: "Commentaire",
      onChange: this.onInputChange
    }))), /*#__PURE__*/React.createElement(Form.Row, null, /*#__PURE__*/React.createElement(Button, {
      block: true,
      variant: "primary",
      type: "submit"
    }, "Confirmer ma r\xE9servation"))))), this.state.step === 5 && /*#__PURE__*/React.createElement("div", {
      className: "reservation-step5"
    }, /*#__PURE__*/React.createElement("p", null, this.props.reservationSettings.confirmationMessage || `
                Merci pour votre réservation. Vous recevrez sous peu un email de confirmation de la part du restaurant.
              `), /*#__PURE__*/React.createElement("p", {
      className: "icon",
      id: "date-confirm"
    }, format(this.state.reservationDate, 'EEEE dd LLLL', {
      locale: fr
    })), /*#__PURE__*/React.createElement("p", {
      className: "icon",
      id: "time-confirm"
    }, format(this.state.reservationDate, 'HH:mm', {
      locale: fr
    })), /*#__PURE__*/React.createElement("p", {
      className: "icon",
      id: "nb-confirm"
    }, this.state.nbAdult, " personne(s)"), this.props.reservationSettings.redirectUrl ? /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: () => {
        window.location.href = this.props.reservationSettings.redirectUrl;
      }
    }, "Retour") : /*#__PURE__*/React.createElement("p", null, "Vous pouvez maintenant fermer cette page.")));
  }

}

export default ReservationForm;